// extracted by mini-css-extract-plugin
module.exports = {"TwoDimsFeature":"vw_a bhb_b bhb_ux"};